module.exports = __webpack_public_path__ + "static/aaron-levie-62b4c3ffc842c0f0e93a968fb12f078c.jpg";